<template><div><h1 id="kontierungsquellen" tabindex="-1"><a class="header-anchor" href="#kontierungsquellen"><span>Kontierungsquellen</span></a></h1>
<p>Kontierungsquellen — Strukturierung der Finanzbuchhaltung</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Je nach Struktur der Unternehmung werden, was die Auf- und Zuteilung von Kosten betrifft, andere Anforderungen an die Finanzbuchhaltung gestellt. Mit der Tabelle Kontierungsquellen können diese unterschiedlichen Bedürfnisse gesteuert werden. Sie bestimmt, aus welcher Quelle das System die Informationen zum Bebuchen von Kombinationen von Kto/Kst/Ktr nimmt. Im Beispiel übernimmt das System sämtliche finanzbuchhaltungsrelevanten Informationen aus dem Artikel. Die Änderung dieser Tabelle hat weitreichende Konsequenzen und darf im laufenden Betrieb nicht umgestellt werden!</p>
<p>Pfad: <code v-pre>Buchhaltung → Tabellen → Kontierungsquellen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>PosNr.</dt>
<dd>Nummer der Kontierungsquelle, 2-stellig, ist im System vorgegeben und darf nicht geändert werden. Es sind auch ausser den gezeigten keine anderen Kontierungsquellen wählbar</dd>
<dt>Bezeichnung</dt>
<dd>Bezeichnung der Kontierungsquelle. Die im Beispiel gezeigten Kontierungsquellen sind im System fix vorgegeben</dd>
<dt>Kto</dt>
<dd>ja = System übernimmt das zu bebuchende Konto aus ...</dd>
<dt>Kst</dt>
<dd>ja = System übernimmt die zu bebuchende Kostenstelle aus ...</dd>
<dt>Ktr</dt>
<dd>ja = System übernimmt den zu bebuchenden Kostenträger aus ...</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<dl>
<dt>ändern</dt>
<dd>Ändern der Steuerungstabelle, aus welchem Bereich das System die Information zu Kto/Kst/Ktr nimmt. &quot;ja&quot; = siehe oben &quot;.&quot; = Information wird bei der Übernahme nicht berücksichtigt</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/buchhaltung/debitorenverwaltung.html" title="Kapitel 6. Buchhaltung">Buchhaltung</RouteLink></p>
</div></template>


